function isEnumValue<T extends Record<string, string>>(
  enumObj: T,
  value: string | null | undefined,
): value is T[keyof T] {
  if (value == null) {
    return false;
  }
  return (Object.values(enumObj) as string[]).includes(value);
}

export function toEnumValue<T extends Record<string, string>>(
  enumObj: T,
  value: string | null | undefined,
): T[keyof T] | undefined {
  return isEnumValue(enumObj, value) ? value : undefined;
}
